import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import Daytrip from './Day Trip Destinations Near Morachi Chincholi Pune';

function Dayoutiingplace() {



    const cardData =
    {
        keyword: 'Day Outing Place Anand Krushi Paryatan Kendra Morachi Chincholi Pune',
        heading: 'Anand Krushi Paryatan Kendra: Day Outing Place Anand Krushi Paryatan Kendra Morachi Chincholi Pune',
        headingDescription: 'Escape the chaos of urban life with a refreshing one-day retreat to Anand Krushi Paryatan Kendra, a scenic 40-acre agri-tourism center located in Morachi Chincholi, just 55 km from Pune. Surrounded by lush greenery and the soothing sounds of nature, this eco-friendly getaway offers the perfect blend of rural charm and modern leisure. Ideal for families, school trips, and corporate outings, this Day Outing Place Anand Krushi Paryatan Kendra Morachi Chincholi Pune provides a full-day experience featuring bullock cart and tractor rides, horse riding, swimming, boating, rain dance, puppet and magic shows, and a variety of adventure and traditional village games.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Early Morning Tractor Safari",
    "description": "Kickstart your rural retreat with a breezy tractor safari through expansive farmlands, vibrant marigold patches, and swaying mustard fields. This scenic ride offers panoramic views of the countryside, a chance to interact with local farmers, and moments to capture Instagram-worthy sunrise photos — all while sitting on a colorfully decorated traditional tractor that sets the tone for a truly rustic day."
  },
  {
    "title": "Hands‑On Organic Farming Experience",
    "description": "Participate in hands-on farming where you can sow seeds, pluck seasonal vegetables, and try composting methods used by real village farmers. Learn how organic food is grown using traditional techniques like bullock-ploughing, mulching, and drip irrigation. This immersive session fosters a deeper connection with the soil, and kids especially love digging in and discovering where their food comes from."
  },
  {
    "title": "Village‑Style Breakfast Feast",
    "description": "After working up an appetite, enjoy a farm-fresh breakfast made with love—think spicy misal-pav, tangy thecha served with bhakri, sabudana khichdi, and piping hot tea brewed over a wood-fired chulha. Served in a bamboo-covered seating area surrounded by lush greenery, this meal offers both nutrition and nostalgia, making it a highlight of your visit."
  },
  {
    "title": "Rural Games & Family Fun",
    "description": "Revisit your childhood with traditional Indian games like gilli-danda, lagori, kabaddi, kho-kho, and sack races. Large open grounds allow everyone to freely play, laugh, and bond—be it kids discovering new games or adults reliving theirs. The kendra also provides bamboo swings, rope walks, and tire-balancing zones to keep all age groups joyfully engaged."
  },
  {
    "title": "Nature Trail & Bird Watching",
    "description": "Wander along well-marked nature trails that weave through the farm’s outskirts and observe native flora and fauna in peace. Early morning or late afternoon strolls often include glimpses of parrots, kingfishers, bulbuls, and even peacocks fluttering by the banyan and tamarind trees. It’s a perfect activity for bird lovers and peace seekers alike."
  },
  {
    "title": "Interactive Dairy & Milking Demo",
    "description": "Witness and participate in the milking of cows using age-old hand techniques, guided by the farm's caretakers. Learn how milk is filtered, boiled, and turned into ghee or curd. Children especially enjoy feeding the calves or watching buffaloes bathe in the nearby pond — offering a wholesome view of rural dairy life that's both educational and fun."
  },
  {
    "title": "Rustic Lunch on Banana Leaves",
    "description": "Feast on an unlimited Maharashtrian thali served with love on fresh-cut banana leaves — featuring dishes like zunka-bhakar, bharli vangi, pithla, varan-bhat, pickles, and cooling taak. The authentic taste is enhanced by open-air seating, folk music, and a backdrop of swaying sugarcane fields. A truly soulful rural lunch that satisfies both your palate and heart."
  },
  {
    "title": "Craft Workshop: Pottery & Weaving",
    "description": "Join hands-on workshops where local artisans teach you the art of clay pottery, mud toys, and traditional weaving with banana fiber or jute. Paint your own diyas or make a tiny pot on the wheel, and take home a handcrafted souvenir made by you. These sessions are perfect for kids, creative adults, and couples seeking a unique, memorable experience."
  },
  {
    "title": "Water Splash Zone & Rain Dance",
    "description": "Unwind in the dedicated splash zone equipped with water jets, kiddie pools, and colorful slides. Groove under the rain dance canopy with lively Marathi beats or Bollywood DJ remixes. It’s a great way to cool off after a day of activities—especially loved by children and young adults during weekends, summer holidays, and group outings."
  },
  {
    "title": "Sunset Nature Stroll & Bonfire",
    "description": "As the sun sets behind the sugarcane fields, take a golden-hour stroll around the property or rest beneath the banyan tree to watch the sky change colors. Later, gather around a cozy bonfire with your group for folk tales, live music, bhadang-snacks, or even dholki singing. A soothing close to a lively rural day, perfect for creating lasting memories."
  }
],




"services": [
  {
    "name": "Popular Tourist Spots in Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra ranks high among the most popular tourist spots in Morachi Chincholi, thanks to its serene rural setup, traditional farming experiences, and up-close encounters with peacocks and village life. It's perfect for a one-day immersive escape from the city."
  },
  {
    "name": "Bird Sanctuary Attractions",
    "description": "Located in the peacock belt of Morachi Chincholi, Anand Krushi Paryatan Kendra offers daily sightings of Indian Peafowls in their natural habitat. Visitors can enjoy early morning walks to observe and photograph these beautiful birds amidst a lush, peaceful farm landscape."
  },
  {
    "name": "Farm Tourism Activities",
    "description": "From vegetable picking and bullock cart rides to hands-on farming, Anand Krushi Paryatan Kendra offers interactive farm tourism activities ideal for families, school groups, and urban dwellers curious about village life. The experience is both fun and educational."
  },
  {
    "name": "Adventure Zones in Morachi Chincholi",
    "description": "For those seeking light adventure, Anand Krushi Paryatan Kendra provides rural-themed challenges such as rope balancing, climbing frames, and traditional village sports. These activities offer a rustic twist on modern adventure zones in a natural setting."
  },
  {
    "name": "Eco-Tourism Centers",
    "description": "As a model eco-tourism destination near Pune, Anand Krushi Paryatan Kendra promotes sustainability through organic farming, waste composting, and water conservation. It’s a great visit for conscious travelers seeking an earth-friendly rural experience."
  },
  {
    "name": "Wildlife Viewing Areas",
    "description": "Apart from peacocks, the farm is home to several native bird species, butterflies, and small mammals. Visitors can take slow nature walks through fields and tree groves for casual wildlife viewing without needing to travel to a formal sanctuary."
  },
  {
    "name": "Local Cultural Festivals",
    "description": "Anand Krushi Paryatan Kendra celebrates local festivals like Makar Sankranti, Holi, and Diwali with traditional village flair. Guests during festival weekends can enjoy folk dances, traditional games, rangoli making, and authentic Maharashtrian food."
  },
  {
    "name": "Nature Trails and Walks",
    "description": "Take a break with peaceful walks through mango orchards, vegetable gardens, and shaded trails. These nature walks at Anand Krushi Paryatan Kendra are perfect for reconnecting with nature while observing seasonal flora and fauna."
  },
  {
    "name": "Photography Hotspots",
    "description": "Photographers love Anand Krushi Paryatan Kendra for its colorful rural scenes, candid moments with animals, and of course, majestic peacocks in full feather. Golden hour shots amidst the fields are especially popular among visitors and influencers."
  },
  {
    "name": "Camping Sites",
    "description": "While Anand Krushi Paryatan Kendra primarily offers day visits, it also facilitates basic camping on request. Camp under the stars in safe, open farm surroundings and enjoy a rustic overnight experience with bonfire activities and traditional food."
  },
  {
    "name": "Food and Local Cuisine Spots",
    "description": "Taste rural Maharashtra at its finest with traditional meals served at Anand Krushi Paryatan Kendra. Dishes include bhakri, pitla, varan-bhat, chutneys, and seasonal mango delights like aamras—all cooked using locally grown ingredients on wood-fired stoves."
  },
  {
    "name": "Guided Tours in Morachi Chincholi",
    "description": "Learn about rural life and sustainable farming practices with guided tours at Anand Krushi Paryatan Kendra. Hosts walk you through the fields, explain crop cycles, and even let you try your hand at traditional farming tools and irrigation methods."
  },
  {
    "name": "Family Outing Destinations",
    "description": "Safe, scenic, and activity-filled—Anand Krushi Paryatan Kendra is a top family outing spot near Morachi Chincholi. With kid-friendly games, animal interactions, shaded seating, and delicious meals, families can enjoy quality time without screens or stress."
  },
  {
    "name": "Educational Tours for Kids",
    "description": "Schools often organize day trips to Anand Krushi Paryatan Kendra to teach children about agriculture, sustainability, and biodiversity. Kids get to experience the origin of their food, engage in hands-on learning, and have a lot of fun doing it."
  },
  {
    "name": "Historical Landmarks",
    "description": "While Anand Krushi Paryatan Kendra is not a historical site itself, it’s located within driving distance of historical landmarks like Shivneri Fort and Bhuleshwar Temple. Combine a heritage visit with a refreshing farm lunch for a balanced day trip."
  }
],
"tableData": [
  ["Popular Tourist Spots in Morachi Chincholi", "- Bird Sanctuary Attractions"],
  ["Farm Tourism Activities", "- Adventure Zones in Morachi Chincholi"],
  ["Eco-Tourism Centers", "- Wildlife Viewing Areas"],
  ["Local Cultural Festivals", "- Nature Trails and Walks"],
  ["Photography Hotspots", "- Camping Sites"],
  ["Food and Local Cuisine Spots", "- Guided Tours in Morachi Chincholi"],
  ["Family Outing Destinations", "- Educational Tours for Kids"],
  ["Historical Landmarks", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Easy Accessibility from Pune",
    "WhyChoosedescription": "Located just 55 km from Pune, Morachi Chincholi is easily reachable by car or bus, making it a convenient day trip destination for locals and tourists alike."
  },
  {
    "WhyChooseheading": "Famous Peacock Sanctuary",
    "WhyChoosedescription": "Known as the 'Peacock Village,' it is home to thousands of peacocks that roam freely in the tamarind groves, offering a unique wildlife experience rarely seen near urban areas."
  },
  {
    "WhyChooseheading": "Rich Agritourism Experience",
    "WhyChoosedescription": "Visitors can enjoy bullock cart rides, tractor tours, organic farm visits, and interact with local farmers, gaining insight into traditional farming practices and rural life."
  },
  {
    "WhyChooseheading": "Wide Range of Activities",
    "WhyChoosedescription": "From adventure sports like zip-lining and archery to cultural shows such as puppet and magic shows, Morachi Chincholi offers entertainment for all ages."
  },
  {
    "WhyChooseheading": "Family-Friendly Environment",
    "WhyChoosedescription": "With dedicated play areas for kids, animal feeding zones, and peaceful spots for relaxation, it’s an ideal outing for families seeking both fun and tranquility."
  },
  {
    "WhyChooseheading": "Seasonal Festivals and Local Events",
    "WhyChoosedescription": "Enjoy authentic village festivals like Hurda parties and Mango Mahotsav, featuring local produce, music, dance, and traditional celebrations."
  },
  {
    "WhyChooseheading": "Affordable Visit Packages",
    "WhyChoosedescription": "The spot offers budget-friendly packages that include meals, activities, and guided tours, making it accessible to a wide range of visitors."
  },
  {
    "WhyChooseheading": "Eco-Friendly and Sustainable Tourism",
    "WhyChoosedescription": "Morachi Chincholi promotes eco-conscious tourism with organic farming practices and conservation efforts, ensuring a responsible travel experience."
  }
]









    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Why is Morachi Chincholi a popular tourist spot near Pune?',
    answer: 'Morachi Chincholi is famous for its large population of peacocks, scenic rural environment, and authentic agritourism experiences, all just about 65 km from Pune.',
  },
  {
    id: 'FAQ2',
    question: 'What activities can tourists enjoy at Morachi Chincholi?',
    answer: 'Visitors can enjoy peacock and bird watching, pony rides, tractor rides, farm walks, traditional village games, and savor local Maharashtrian food.',
  },
  {
    id: 'FAQ3',
    question: 'Is Morachi Chincholi suitable for family outings?',
    answer: 'Yes, it offers a safe and engaging environment for children and adults, with plenty of outdoor activities and educational experiences.',
  },
  {
    id: 'FAQ4',
    question: 'How do I reach Morachi Chincholi from Pune?',
    answer: 'Morachi Chincholi is accessible via a 1.5-hour drive from Pune, mainly through Alandi or Chakan, with good road connectivity.',
  },
  {
    id: 'FAQ5',
    question: 'What is the best time to visit Morachi Chincholi?',
    answer: 'The monsoon and post-monsoon season (June to November) is ideal for lush greenery and active peacock sightings.',
  },
  {
    id: 'FAQ6',
    question: 'Are there any accommodations available nearby?',
    answer: 'Several agritourism centers provide basic overnight stays; however, most visitors prefer day trips.',
  },
  {
    id: 'FAQ7',
    question: 'Are guided tours available at Morachi Chincholi?',
    answer: 'Yes, some centers offer guided tours and nature walks that provide insight into local flora, fauna, and farming practices.',
  },
  {
    id: 'FAQ8',
    question: 'Is photography allowed?',
    answer: 'Absolutely! The vibrant peacocks and scenic landscapes make it a favorite spot for photographers.',
  },
  {
    id: 'FAQ9',
    question: 'What facilities are available for tourists?',
    answer: 'Facilities include parking, restrooms, picnic spots, and refreshment stalls at major agritourism centers.',
  },
  {
    id: 'FAQ10',
    question: 'Can corporate groups organize team outings here?',
    answer: 'Yes, some centers offer customized packages for corporate team-building and recreational activities.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Kulkarni, Pune',
    feedback: "Morachi Chincholi is an excellent getaway from the city. The vibrant peacocks and farm activities provided a refreshing break for our family.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Deshpande, Pune',
    feedback: "Loved the rural charm and peaceful surroundings. The guided nature walk was informative, and the local food was delightful.",
    rating: 5,
  },
];









    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Day Outing Place Anand Krushi Paryatan Kendra Morachi Chincholi Pune",
  "image": "https://morachichincholi.in/assets/images/day-outing-anand-krushi-paryatan-kendra.jpg",
  "description": "Spend a refreshing day at Anand Krushi Paryatan Kendra in Morachi Chincholi, Pune. Enjoy hands-on farm experiences, bird watching, organic farming demos, nature walks, kid-friendly activities, and eco-friendly farm-to-table dining.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2456"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "700",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/day-outing-anand-krushi-paryatan-kendra"
  }
};



    return (
        <div>
<Helmet>
  <title>Day Outing Place at Anand Krushi Paryatan Kendra Morachi Chincholi Pune | Farm Fun & Nature Activities</title>
  <meta 
    name="description" 
    content="Plan your day outing at Anand Krushi Paryatan Kendra in Morachi Chincholi Pune. Experience farm tours, bird watching, nature walks, organic farming, kids’ activities, and eco-friendly dining in a peaceful rural setting." 
  />
  <meta 
    name="keywords" 
    content="Farm experience activities at Anand Krushi Paryatan Kendra, Agricultural tours for families, Interactive farming workshops, Organic farming demonstrations, Nature walks at the center, Kids-friendly activities, Bird watching spots, Picnic zones at Anand Krushi Paryatan Kendra, Farm-to-table dining options, Cultural events hosted here, Educational tours for students, Adventure activities nearby, Guided farm tours, Local produce markets, Eco-friendly experiences" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/9.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Dayoutiingplace;